import type { BusinessConnectionMst, Common } from '@libs/domain';
import type { BusinessConnectionType, EligibleBillingProvider } from '@libs/enums';
import { MstListSearch, MstListSearchRaw } from '@libs/templates/mst';

class BusinessConnectionMstListSearch
  extends MstListSearch
  implements
    Pick<BusinessConnectionMst['schema'], 'businessConnectionClass'>,
    Pick<Common['schema'], 'eligibleBillingProviderCondition'>
{
  private constructor(
    mstListSearch: MstListSearch,
    readonly businessConnectionClass: Set<BusinessConnectionType>,
    readonly eligibleBillingProviderCondition: Set<EligibleBillingProvider>,
  ) {
    super(
      mstListSearch.codeRange,
      mstListSearch.name,
      mstListSearch.mstSpareName01Condition,
      mstListSearch.mstSpareName02Condition,
      mstListSearch.validityStartDateCondition,
      mstListSearch.validityEndDateCondition,
      mstListSearch.mstNoteCondition,
    );
  }

  static init(businessConnectionClass?: BusinessConnectionType) {
    return new BusinessConnectionMstListSearch(
      MstListSearch.baseInit(),
      businessConnectionClass ? new Set([businessConnectionClass]) : new Set(),
      new Set(),
    );
  }
}

class BusinessConnectionMstListSearchRaw
  extends MstListSearchRaw
  implements
    Pick<BusinessConnectionMst['record'], 'businessConnectionClass'>,
    Pick<Common['record'], 'eligibleBillingProviderCondition'>
{
  private constructor(
    mstListSearchRaw: MstListSearchRaw,
    readonly businessConnectionClass: string[],
    readonly eligibleBillingProviderCondition: string[],
  ) {
    super(
      mstListSearchRaw.codeRange,
      mstListSearchRaw.isCodeRangeExcluded,
      mstListSearchRaw.name,
      mstListSearchRaw.mstSpareName01,
      mstListSearchRaw.isMstSpareName01BlankOnly,
      mstListSearchRaw.mstSpareName02,
      mstListSearchRaw.isMstSpareName02BlankOnly,
      mstListSearchRaw.validityStartDateFrom,
      mstListSearchRaw.validityStartDateTo,
      mstListSearchRaw.validityEndDateFrom,
      mstListSearchRaw.validityEndDateTo,
      mstListSearchRaw.mstNote,
      mstListSearchRaw.isMstNoteBlankOnly,
    );
  }

  static fromModel(model: BusinessConnectionMstListSearch) {
    return new BusinessConnectionMstListSearchRaw(
      MstListSearchRaw.baseFromModel(model),
      [...model.businessConnectionClass],
      [...model.eligibleBillingProviderCondition],
    );
  }
}

export { BusinessConnectionMstListSearch, BusinessConnectionMstListSearchRaw };
